import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select, IconButton } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, PersonAdd as IconPersonAdd } from "@mui/icons-material";
import comprobanteService from "../../services/comprobanteService";
import * as catalogoService from "../../services/catalogoService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setResults, setListTipo, setListEstadoPago, setListEstado } from '../../redux/receiptSearchSlice';
import { setPersonList } from "../../redux/personSlice";
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Catalogo 143 = Estados de Pago del comprobante.
const ESTADO_PAGO_PENDIENTE = 144;

const Index = () => {
    const { isReadOnly } = useMantenimiento("comprobante");
    const filters = useSelector((state) => state.receiptSearch.filters);
    const listTipo = useSelector((state) => state.receiptSearch.listTipo);
    const listEstadoPago = useSelector((state) => state.receiptSearch.listEstadoPago);
    const listEstado = useSelector((state) => state.receiptSearch.listEstado);

    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchResults = async () => {
        setCargando(true);

        // Las fechas van en hora local: con toISOString se correrian un dia.
        const fechaInicioFiltro = filters.fechaInicio == null
            ? null
            : moment(filters.fechaInicio).startOf("day").format("YYYY-MM-DD HH:mm:ss");
        const fechaFinFiltro = filters.fechaFin == null
            ? null
            : moment(filters.fechaFin).endOf("day").format("YYYY-MM-DD HH:mm:ss");

        const filtersToSend = {
            fechaInicio: fechaInicioFiltro,
            fechaFin: fechaFinFiltro,
            idTipo: filters.idTipo == null ? 0 : filters.idTipo,
            serie: filters.serie == null ? "" : filters.serie,
            numero: filters.numero == null || filters.numero === "" ? 0 : parseInt(filters.numero),
            idCobrador: filters.idCobrador == null ? 0 : filters.idCobrador,
            dniCobrador: filters.dniCobrador == null ? "" : filters.dniCobrador,
            idPagador: filters.idPagador == null ? 0 : filters.idPagador,
            dniPagador: filters.dniPagador == null ? "" : filters.dniPagador,
            idEstadoPago: filters.idEstadoPago == null ? 0 : filters.idEstadoPago,
            idEstado: filters.idEstado == null ? 0 : filters.idEstado
        };

        await comprobanteService.getsComprobanteResumenViewFilter(filtersToSend)
            .then((response) => {
                setResults(response.data.data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchListTipo = async () => {
        const data = await catalogoService.getCatalogosByPadre(140)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
        dispatch(setListTipo(data));
    }
    const fetchListEstadoPago = async () => {
        const data = await catalogoService.getCatalogosByPadre(143)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
        dispatch(setListEstadoPago(data));
    }
    const fetchListEstado = async () => {
        const data = await catalogoService.getCatalogosByPadre(1)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
        dispatch(setListEstado(data));
        dispatch(setValue({name: "idEstado", value: 2}))
    }
    const annul = async () => {
        await comprobanteService.annulComprobante(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    const active = async () => {
        await comprobanteService.activeComprobante(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }

    useEffect(() => {
        fetchResults();
        fetchListTipo();
        fetchListEstadoPago();
        fetchListEstado();
    }, []);

    // El simbolo de la moneda se muestra junto al monto: la moneda y el tipo de
    // cambio ya no tienen columna propia.
    const SIMBOLO_MONEDA = {
        S: "S/",
        D: "US$",
    };

    const simboloMoneda = (row) => SIMBOLO_MONEDA[row?.monedaCodigo] || row?.monedaAbreviado || "";

    const columns = [
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'tipoAbreviado', headerName: 'Tipo', width: 45, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'serieNumero', headerName: 'Serie-Numero', width: 130, sortable: true, headerAlign: 'center'
            , renderCell: (cellValues) => (
                <Link to={'/receipt/edit/' + cellValues.row.id} style={{ color: 'inherit' }}>
                    {cellValues.row.serieNumero}
                </Link>
            )
        },
        { field: 'fecha', headerName: 'Fecha', width: 100, type: 'date'
                    , valueFormatter: (value) => moment(value).format('D/MM/YYYY')
                    , sortable: false, headerAlign: 'center', align: 'center' },
        // El link para registrar pago va en la cuarta columna para que tambien
        // se vea desde el celular.
        { field: 'pago', headerName: 'Registrar', width: 90, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                const row = cellValues.row;

                // Solo se puede registrar pago de un comprobante pendiente.
                if (row.idEstadoPago != ESTADO_PAGO_PENDIENTE) return null;

                return <Link to={'/receipt/pago/' + row.id}>Pago</Link>;
            }
        },
        { field: 'pagador', headerName: 'Pagador', width: 160, sortable: false, headerAlign: 'center' },
        { field: 'montoTotal', headerName: 'Total', width: 100, sortable: false, headerAlign: 'right', align: 'right'
            , renderCell: (cellValues) => simboloMoneda(cellValues.row) + " " + (parseFloat(cellValues.row.montoTotal) || 0).toFixed(2) },
        { field: 'montoSaldo', headerName: 'Saldo', width: 100, sortable: false, headerAlign: 'right', align: 'right'
            , renderCell: (cellValues) => simboloMoneda(cellValues.row) + " " + (parseFloat(cellValues.row.montoSaldo) || 0).toFixed(2) },
        { field: 'estadoPago', headerName: 'Pago', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estado', headerName: 'Estado', width: 70, sortable: false, headerAlign: 'center' },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"} disabled={isReadOnly} onClick={() => {
                    setSelectId(cellValues.row.id);
                    setSelectState(cellValues.row.estado);
                    setOpenDialogAnnulActive(true);
                }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Comprobantes
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    name="fechaInicio"
                                    label="Inicio"
                                    fullWidth
                                    type="date"
                                    //defaultValue={moment()}
                                    value={moment(filters.fechaInicio).format('yyyy-MM-DD')}
                                    onChange={(event) => {
                                        dispatch(setValue({name: "fechaInicio", value: event.target.value}))
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    name="fechaFin"
                                    label="Fin"
                                    fullWidth
                                    type="date"
                                    //defaultValue={moment()}
                                    value={moment(filters.fechaFin).format('yyyy-MM-DD')}
                                    onChange={(event) => {
                                        dispatch(setValue({name: "fechaFin", value: event.target.value}))
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-idtipo">Tipo</InputLabel>
                                    <Select
                                        native
                                        label="Tipo"
                                        value={filters.idTipo}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idTipo", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idTipo',
                                            id: 'input-idtipo',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listTipo.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} sm={3}>
                                <TextField
                                    name="serie"
                                    label="Serie"
                                    value={filters.serie}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "serie", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={8} sm={3}>
                                <TextField
                                    name="numero"
                                    label="Numero"
                                    value={filters.numero}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "numero", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={8} sm={3}>
                                <TextField
                                    name="dniCobrador"
                                    label="Cobrador"
                                    value={filters.dniCobrador}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "dniCobrador", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={8} sm={3}>
                                <TextField
                                    name="cobrador"
                                    label=""
                                    value={filters.cobrador}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "cobrador", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={8} sm={3}>
                                <TextField
                                    name="dniPagador"
                                    label="Pagador"
                                    value={filters.dniPagador}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "dniPagador", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={8} sm={3}>
                                <TextField
                                    name="pagador"
                                    label=""
                                    value={filters.pagador}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "pagador", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estadopago">Pago</InputLabel>
                                    <Select
                                        native
                                        label="Pago"
                                        value={filters.idEstadoPago}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstadoPago", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstadoPago',
                                            id: 'input-estadopago',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstadoPago.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado">Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstado", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstado.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} sm={2} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconPersonAdd />,
                                        onClick: () => navigate("/receipt/edit/0")
                                    }
                                ]}
                                // onNewClick={() => navigate(`/receipt/edit/0`)}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annul : active} 
                        setNo={() => { return }}
                        titulo={(selectState == "A" ? "Anular" : "Activar") + " Comprobante"}
                        texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " el comprobante?"} >
                    </DialogYesNo>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index
